/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { GET, PUT } from '../../../helpers/httphelper';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { storage } from '../../../helpers/Firebase';
import '../../../assets/styles/userprofile.css';
import ProfilePic from '../../../assets/images/profile.svg';
import { Link } from 'react-router-dom';
import { toast as superToast } from 'bulma-toast'



function UserProfile() {

    const [currentUser, setcurrentUser] = useState("")
    const userId = localStorage.getItem("user");
    // const [profileDate, setProfileDate] = useState()
    const [currentpassword, setcurrentpassword] = useState("")
    const [newpassword, setnewpassword] = useState("")

    const [FileUrl, setFileUrl] = useState("")

    const [Progress, setProgress] = useState(0)
    const updatepic = () => {
        const profile = { image: FileUrl }
        PUT(`api/user/updateimg/${userId}`, profile).then(res => {

            superToast({
                message: "Profile picture updated successfully",
                type: 'is-success',
                dismissible: true,
                position: "top-center",
                animate: { in: 'fadeIn', out: 'fadeOut' },
            })
            Getoneuser()


        }).catch(err => { })
    }

    const handlePhotoInput = (e) => {
        e.preventDefault();
        const file = e.target.files[0]; //get file
        console.log(file.name);
        fileName.current.innerText = file.name; //set file name
        fileName.current.style.color = 'black'; //set file name color
        if (!file) { //if no file is selected
            return;
        } else { //if file is selected

            const storageRef = ref(storage, `/users/${file.name}`); //get file reference
            const uploadTask = uploadBytesResumable(storageRef, file); //upload file

            uploadTask.on("state_changed", (snapshot) => { //listen for state changes
                const prog = Math.round( //get progress percentage
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100 //calculate progress percentage
                ); //end get progress percentage
                setProgress(prog); //set progress
            }, (err) => {
                console.log(err);
            }, () => {
                getDownloadURL(uploadTask.snapshot.ref).then((url) => {
                    setFileUrl(url);
                    console.log(url);
                })
            })
        }
    }

    const fileName = useRef();

    useEffect(() => {
        Getoneuser();
    }, [])

    const Getoneuser = () => {

        try {
            GET(`api/user/getuser/${userId}`).then(res => {
                setcurrentUser(res.user)
                if (res.user.image) {
                    setFileUrl(res.user.image)
                }

                console.log(FileUrl)
                console.log(res)
            })
        } catch (err) {
            throw err;
        }
    }

    const changepassword = () => {
        document.getElementById("pass").classList.add("is-active")
    }

    const hidepassword = () => {
        document.getElementById("pass").classList.remove("is-active")
    }

    const updatePassword = (e) => {
        e.preventDefault();

        try {
            PUT(`api/user/updatepw/${userId}`, { currentpassword, newpassword }).then(res => {
                console.log(res)
                superToast({
                    message: "Password Updated successfully",
                    type: 'is-success',
                    dismissible: true,
                    position: "top-center",
                    animate: { in: 'fadeIn', out: 'fadeOut' },
                })
                hidepassword()
            })
        } catch (err) {
            console.log(err)
        }
    }


    return (
        <div className='container'>
            <Link to="../dashboard"><h1 className='has-text-left mt-3'><i class="fas fa-arrow-circle-left"></i></h1></Link>
            <div className='columns'>
                <div className='column is-6 mt-6'>
                    <div className='columns is-justify-content-center'>

                        <div className='column is-6 mt-6'>
                            <figure className="image" style={{ textAlign: '-webkit-center' }}>
                                <img alt="" src={FileUrl === '' ? ProfilePic : FileUrl} className="profile-pic" />
                            </figure>
                            <div className='mt-2'>
                                <input className="input has-background-light" style={{ display: 'none' }} onChange={(e) => handlePhotoInput(e)} type="file" name="resume" id="imageupload" />
                                <label ref={fileName} htmlFor='imageupload' className="input has-background-light" style={{ color: '#e1e1e1' }}>
                                    Upload Image
                                </label>
                            </div>
                            <div className="progressText mt-1">
                                <progress className="progress is-success" value={Progress} max="100">{Progress}</progress>
                            </div>
                            <div className='mt-2'>
                                {FileUrl &&
                                    <h1 className='has-text-centered'>
                                        <button type='submit' className='button is-primary' onClick={(e) => { updatepic() }} >upload</button>
                                    </h1>
                                }
                            </div>
                            <div className='mt-2'>
                                <h1 className='has-text-centered'>
                                    <button type='submit' className='button is-danger' onClick={(e) => { changepassword() }} >change password</button>
                                </h1>
                            </div>
                        </div>
                    </div>

                </div>
                <div className='column is-6 mt-6'>
                    <form>
                        <h1 className='title is-2 has-text-centered'>Profile</h1>

                        <div className='columns is-justify-content-center is-mobile mb-0'>
                            <div className='column is-5'>
                                <div className="field">
                                    <label className="label">First Name</label>
                                    <div className="control">
                                        <input required className="input" type="text" placeholder='First Name' defaultValue={currentUser?.fname} readOnly disabled />
                                    </div>
                                </div>
                            </div>

                            <div className='column is-5'>
                                <div className="field">
                                    <label className="label">Last Name</label>
                                    <div className="control">
                                        <input required className="input" type="text" placeholder='Last Name' defaultValue={currentUser?.lname} readOnly disabled />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='columns is-justify-content-center is-mobile mb-0'>
                            <div className='column is-10'>
                                <div className="field">
                                    <label className="label">Email</label>
                                    <div className="control">
                                        <input required className="input" type="email" placeholder='Email' defaultValue={currentUser?.email} readOnly disabled />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='columns is-justify-content-center is-mobile mb-0'>
                            <div className='column is-10'>
                                <div className="field">
                                    <label className="label">NIC</label>
                                    <div className="control">
                                        <input required className="input" type="text" placeholder='NIC' defaultValue={currentUser?.nic} readOnly disabled />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='columns is-justify-content-center is-mobile  mb-0'>
                            <div className='column is-5 '>
                                <div className="field">
                                    <label className="label">Date Of Birth</label>
                                    <div className="control">
                                        <input required className="input" type="text" defaultValue={(currentUser?.birth)?.split('T')[0]} readOnly disabled />
                                    </div>
                                </div>
                            </div>

                            <div className='column is-5'>
                                <div className="field">
                                    <label className="label">Age</label>
                                    <div className="control">
                                        <input required className="input" type="text" placeholder='Age' defaultValue={currentUser?.age} readOnly disabled />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='columns is-justify-content-center is-mobile mb-0'>
                            <div className='column is-10'>
                                <div className="field">
                                    <label className="label">Gender</label>
                                    <div className="control">
                                        <input className="input" type="text" placeholder='Gender' defaultValue={currentUser?.gender} readOnly disabled />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='columns is-justify-content-center is-mobile mb-0'>
                            <div className='column is-10'>
                                <div className="field">
                                    <label className="label">Mobile</label>
                                    <div className="control">
                                        <input className="input" type="tel" placeholder='Mobile number' defaultValue={currentUser?.mobile} readOnly disabled />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <h1 className='has-text-centered'>
                            <Link to={"/user/update/" + currentUser?._id}>
                                <button type='submit' className='button is-info' >Update</button>
                            </Link>
                        </h1>
                    </form>
                </div>
            </div>
            <div className="modal" id="pass">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head">
                        <p className="modal-card-title">Change Password</p>
                        <button className="delete" aria-label="close" onClick={(e) => { hidepassword() }}></button>
                    </header>
                    <section className="modal-card-body">
                        <form onSubmit={updatePassword}>
                            <div className='columns is-justify-content-center is-mobile mb-0'>
                                <div className='column is-10'>
                                    <div className="field">
                                        <label className="label">Current Password</label>
                                        <div className="control">
                                            <input required className="input is-info" type="password" placeholder='Current Password' onChange={(e) => { setcurrentpassword(e.target.value) }} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='columns is-justify-content-center is-mobile mb-0'>
                                <div className='column is-10'>
                                    <div className="field">
                                        <label className="label">New Password</label>
                                        <div className="control">
                                            <input required className="input is-info" type="password" placeholder='New Password' onChange={(e) => { setnewpassword(e.target.value) }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h1 className="has-text-centered"> <button className="button is-success" type="submit" >Save changes</button></h1>

                        </form>
                    </section>

                </div>
            </div>
        </div >
    );




}

export default UserProfile;